import React from 'react';

const CalendarDateIcon = (props: any) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4.3776 1.75V3.50073" strokeWidth="1.05" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.62956 1.75V3.50073" strokeWidth="1.05" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1.75122 5.54472H12.2556" strokeWidth="1.05" strokeLinecap="round" strokeLinejoin="round" />
    <rect
      x="1.75134"
      y="2.62793"
      width="10.5044"
      height="9.62901"
      rx="2.1"
      strokeWidth="1.05"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CalendarDateIcon;
